export default __webpack_public_path__ + "static/Image083-29f0e2ec0d282773b4f1ea1efd7da133.png";